import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

// antd
import {
    Col,
    Form,
    Input,
    Row,
    Space,
    Avatar,
    Typography,
    DatePicker,
    Spin,
    message,
    Tabs,
    Tooltip,
    Image,
    Flex,
    Drawer,
    Card,
} from 'antd'
import { Icon } from '@iconify/react'

import {
    FilePdfOutlined,
    FileWordOutlined,
    FileExcelOutlined,
    FileImageOutlined,
    FileOutlined,
} from '@ant-design/icons'

// slices
import { projectsState } from '../../projects/projects.slice'
import {
    switchFormModal,
    supportState,
    updateSupportComment,
    supportTaskById,
} from './support.slice'
import { loginState } from '../../login/login.slice'

// sections
import SupportCommentsSection from './SupportCommentsSection'

// sections
import SupportSubTaskSection from './SupportSubTaskSection'

// attachments
import SupportAttachmentSection from './SupportAttachmentSection'

// styles
import styles from '../tasks.module.css'

// constants
import { ESTIMATION_PATTERN } from '../../../constants/patterns'
import { priorityType } from '../../../constants/tasks.index'

import dayjs from 'dayjs'
import { convertUTCToLocal } from '../../../helpers/utils'
import { PRIVATE_ROUTES } from '../../../routes'

import '../tasks.index.css'
import PrioritySelector from '../components/prioritySelector'
import StatusSelector from '../components/statusSelector'
import AssigneeSelectPopover from '../components/assigneeSelector'
import TaskItemSelector from '../components/taskItemSelector'
import MentionEditor from '../../../components/MentionEditor/MentionEditor'
import S3FileUpload from 'react-s3/lib/ReactS3'
import SupportAttachmentSectionButton from './SupportAttachmentSectionButton'
import SupportActivitySection from './SupportActivitySection'

const SupportTaskForm = ({
    assigneeList,
    onCancel,
    activeTab,
    activeTabName,
    listTaskCall = () => {},
    DateRangeSet,
    isclearForm,
    setIsCleraForm,
}) => {
    const { Text } = Typography

    const { TextArea } = Input

    const { RangePicker } = DatePicker

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const params = useLocation()

    const { userProfile } = useSelector(loginState)
    const { currentProjectData } = useSelector(projectsState)
    const { formModal } = useSelector(supportState)

    const [clearEditor, setClearEditor] = useState(false)
    const [filteredMembers, setFilteredMembers] = useState([])
    const [addCommentLoader, setAddCommentLoader] = useState(false)
    const [mentionData, setMentionData] = useState({
        name: 'React',
        value: '',
        mentionData: null,
        mentionDataList: [],
        comment: '',
        users: [],
    })

    const [commentChange, setCommentChange] = useState([])
    const [files, setFiles] = useState([])
    const { selectedTask, taskStatus } = useSelector(supportState)

    const initialValues = useMemo(() => {
        return {
            title: '',
            type:
                activeTab && !selectedTask
                    ? activeTabName === 'Issues'
                        ? [
                              {
                                  label: 'Bug',
                                  value: 'Bug',
                              },
                          ]
                        : [
                              {
                                  label: 'Task',
                                  value: 'Task',
                              },
                          ]
                    : 'Task',
            status: {},
            rangePicker: [],
            estimation: 0,
            start: '',
            end: '',
            assigneeId: [],
            description: '',
            projectId: '',
        }
    }, [activeTab, activeTabName, selectedTask])
    const [form] = Form.useForm()
    const [swimLanesOption, setSwimLanesOption] = useState([])
    const [taskTypeOption, setTaskTypeOption] = useState([])
    const [values, setValues] = useState(initialValues)
    const [updatedValues, setUpdatedValues] = useState({})
    // Removed edit/delete functionality - Support is view-only
    const [drawerWidth, setDrawerWidth] = useState(window.innerWidth * 0.4)
    const [activeTabComment, setActiveTabComment] = useState('comments')

    // Removed formValue - not needed for read-only

    useEffect(() => {
        if (!formModal) {
            setValues((prev) => ({ ...prev, type: '' }))
        }
    }, [formModal])

    useEffect(() => {
        if (isclearForm) {
            form.setFieldsValue(initialValues)
            setIsCleraForm(false)
        }
    }, [isclearForm, onCancel, form, initialValues, setIsCleraForm])

    // Removed epic and sprint logic - not needed for Support view

    useEffect(() => {
        const handleResize = () => setDrawerWidth(window.innerWidth * 0.36)
        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    // Removed delete functionality - Support is view-only

    useEffect(() => {
        if (userProfile?.activeProject?._id) {
            setValues((prev) => ({
                ...prev,
                projectId: userProfile?.activeProject?._id,
            }))
        }
    }, [userProfile?.activeProject?._id])
    const tabs = [
        {
            key: 'comments',
            label: 'Comments',
            children: (
                <SupportCommentsSection
                    setFilteredMembers={setFilteredMembers}
                    mentionData={mentionData}
                    files={files}
                    setCommentChange={setCommentChange}
                    commentChange={commentChange}
                />
            ),
        },
        {
            key: 'activity',
            label: 'All Activity',
            children: <SupportActivitySection />,
        },
    ]

    const formatDatePicker = (value) => {
        return `${dayjs(value).format('DD MMM YY')}`
    }
    // Removed epic and sprint useEffect hooks - not needed for Support view

    useEffect(() => {
        if (currentProjectData?.swimlanes?.length > 0) {
            const options = currentProjectData?.swimlanes.map((data) => {
                return {
                    label: data?.name,
                    value: data?._id,
                }
            })
            setSwimLanesOption(options)
        }
        if (currentProjectData?.taskType?.length > 0) {
            const options = currentProjectData?.taskType.map((data) => {
                return {
                    label: data,
                    value: data,
                }
            })
            setTaskTypeOption(options)
        }
    }, [currentProjectData])

    // Removed subtask functionality - Support is view-only

    useEffect(() => {
        if (selectedTask !== undefined) {
            const {
                _id: valueAssignee,
                name: labelAssignee,
                profilePicture,
            } = {
                ...selectedTask?.assigneeId[0],
            }
            const new_obj_assignee = Object.assign(
                {},
                {
                    label: labelAssignee && (
                        <Space size="small">
                            {profilePicture ? (
                                <Image
                                    src={profilePicture}
                                    height={'30px'}
                                    preview={false}
                                    width={'30px'}
                                    style={{
                                        borderRadius: '50%',
                                    }}
                                />
                            ) : (
                                <Avatar
                                    style={{
                                        backgroundColor: 'rgb(0 10 129 / 25%)',
                                        cursor: 'pointer',
                                        height: '30px',
                                        width: '30px',
                                    }}
                                >
                                    {labelAssignee[0].toUpperCase()}
                                    {labelAssignee.split(' ')[1] !==
                                        undefined &&
                                    labelAssignee.split(' ')[1] !== ''
                                        ? labelAssignee
                                              .split(' ')[1][0]
                                              .toUpperCase()
                                        : ''}
                                </Avatar>
                            )}
                            <Text
                                style={{
                                    margin: 0,
                                }}
                            >
                                {labelAssignee && labelAssignee}
                            </Text>
                        </Space>
                    ),
                    value: valueAssignee,
                }
            )

            if (selectedTask) {
                const type = [
                    {
                        label: selectedTask?.type,
                        value: selectedTask?.type,
                    },
                ]
                const swimLanes = {
                    label: selectedTask?.status,
                    value: selectedTask?.status,
                }

                form.setFieldsValue({
                    ...selectedTask,
                    type,
                    rangePicker: [
                        convertUTCToLocal(selectedTask?.start ?? ''),
                        convertUTCToLocal(selectedTask?.end ?? ''),
                    ],
                    estimation: checkEstimation(selectedTask?.estimation)
                        .trimStart()
                        .trimEnd(),
                    start: selectedTask?.start
                        ? dayjs(selectedTask?.start, 'YYYY/MM/DD')
                        : '',
                    end: selectedTask?.end
                        ? dayjs(selectedTask?.end, 'YYYY/MM/DD')
                        : '',
                    assigneeId:
                        new_obj_assignee?.label === undefined &&
                        new_obj_assignee?.value === undefined
                            ? []
                            : [{ ...new_obj_assignee }],
                    status: swimLanes,
                })
            }
        } else {
            form.resetFields()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form, selectedTask, activeTab, params])

    // CHECK ESTIMATION
    function checkEstimation(value) {
        let estimateMinutes = `0m`
        let estimateHours = `0h`
        let estimateWeeks = `0w`
        let estimateDays = `0d`
        const defaultTime = currentProjectData?.defaultTime
        const defaultWeek = currentProjectData?.defaultWeek
        let minutes = value
        if (minutes > 60) {
            estimateMinutes = `${minutes % 60}m`
            const hours = parseInt(minutes / 60)
            if (hours >= defaultTime) {
                estimateHours = `${hours % defaultTime}h`
                const days = parseInt(hours / defaultTime)
                if (days > defaultWeek) {
                    estimateDays = `${days % defaultWeek}d`
                    estimateWeeks = `${parseInt(days / defaultWeek)}w`
                } else {
                    estimateDays = `${days}d`
                }
            } else {
                estimateHours = `${hours}h`
            }
        } else {
            estimateMinutes = `${minutes}m`
        }

        const estimationNew = `${
            estimateWeeks.split('w')[0] !== '0' ? `${estimateWeeks} ` : ''
        }${estimateDays.split('d')[0] !== '0' ? `${estimateDays} ` : ''}${
            estimateHours.split('h')[0] !== '0' ? `${estimateHours} ` : ''
        }${estimateMinutes.split('m')[0] !== '0' ? estimateMinutes : ''}`
        form.setFieldValue('estimation', estimationNew.trimStart().trimEnd())
        return estimationNew
    }

    // CHECK ESTIMATION
    function checkFinalEstimation(value) {
        let estimateMinutes = 0

        const splitValue = value.split(' ')

        const defaultTime = currentProjectData?.defaultTime
        const defaultWeek = currentProjectData?.defaultWeek

        splitValue.forEach((data) => {
            if (data.includes('w')) {
                let week = parseInt(data.split('w')[0])
                estimateMinutes += week * defaultWeek * defaultTime * 60
            }
            if (data.includes('d')) {
                let week = parseInt(data.split('d')[0])
                estimateMinutes += week * defaultTime * 60
            }
            if (data.includes('h')) {
                let week = parseInt(data.split('h')[0])
                estimateMinutes += week * 60
            }
            if (data.includes('m')) {
                let week = parseInt(data.split('m')[0])
                estimateMinutes += week
            } else if (
                !data.includes('w') &&
                !data.includes('d') &&
                !data.includes('h') &&
                !data.includes('m')
            ) {
                estimateMinutes = parseInt(data)
            }

            updateDetails('estimation', estimateMinutes)
            checkEstimation(estimateMinutes)
        })
    }

    // Removed delete functionality - Support is view-only

    // Removed update functionality - Support is view-only
    function updateDetails(name, value) {
        // No-op - Support is read-only
    }

    // Removed onFinish - Support is view-only, no create/update
    const onFinish = async () => {
        // No-op - Support is read-only
    }

    const onFinishFailed = () => {}

    const CopyTextButton = ({ text }) => {
        const handleCopy = () => {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    message.success('Link copied!')
                })
                .catch(() => {
                    message.error('Failed to copy link')
                })
        }

        return (
            <Tooltip title="Copy task link">
                <Icon
                    icon="solar:link-outline"
                    height={20}
                    width={20}
                    onClick={handleCopy}
                    style={{
                        cursor: 'pointer',
                    }}
                />
            </Tooltip>
        )
    }

    const onCloseTaskDrawer = () => {
        dispatch(switchFormModal({ open: false }))
        if (params?.search.includes('taskId')) {
            navigate(PRIVATE_ROUTES.tasks)
        }
    }

    // Removed ensureIssueSprintIfNeeded - not needed for read-only

    // ADD COMMENT FOR SUPPORT
    async function addComment(files) {
        setAddCommentLoader(true)
        const result = await dispatch(
            updateSupportComment({
                id: selectedTask?._id,
                data: {
                    fieldName: 'add',
                    comment: {
                        uId: userProfile?._id,
                        username: userProfile?.name,
                        createdDate: new Date().getTime(),
                        content: mentionData?.comment,
                        mentionId: mentionData?.mentionDataList,
                        attachments: files?.length > 0 ? files : [],
                    },
                },
            })
        )

        const data = result?.payload?.data
        if (data) {
            setMentionData({ ...mentionData, value: '', comment: '' })

            setFiles([])
            const { success, message: checkMessage } = data
            if (success) {
                setAddCommentLoader(false)

                const newComment = {
                    uId: userProfile?._id,
                    mentionId: mentionData?.mentionDataList,
                    attachments: files?.length > 0 ? files : [],
                    content: mentionData?.comment,
                    createdDate: new Date().getTime(),
                    user: {
                        _id: userProfile?._id,
                        name: userProfile?.name,
                    },
                    username: userProfile?.name,
                }
                setCommentChange((prev) => [newComment, ...prev])
                message.success(checkMessage)
                // Refresh task data
                await dispatch(supportTaskById({ _id: selectedTask?._id }))
            } else {
                if (checkMessage) {
                    message.error(checkMessage)
                    setAddCommentLoader(false)
                } else {
                    message.error('Something went wrong, try again later.')
                    setAddCommentLoader(false)
                }
            }
        }
    }

    // S3 UPLOAD FILE
    async function s3Upload() {
        let fileUpload = []
        let stream = true
        setAddCommentLoader(true)
        if (files?.length > 0) {
            files?.length > 0 &&
                files.forEach((data) => {
                    const nameChange = data?.name
                        .split('.')[0]
                        .concat(`_${dayjs(new Date()).unix()}`)
                        .concat(`.${data?.name.split('.')[1]}`)

                    const newFileData = new File(
                        [data?.originFileObj],
                        nameChange,
                        { type: data?.type }
                    )
                    window.Buffer = window.Buffer || require('buffer').Buffer

                    S3FileUpload.uploadFile(newFileData, userProfile?.s3Config)
                        .then(async (data) => {
                            if (files?.length === fileUpload?.length + 1) {
                                stream = false
                            }
                            fileUpload.push(data?.location)
                            if (stream === false) {
                                addComment(fileUpload)
                                setClearEditor(true)
                            }
                        })
                        .catch(() => {
                            message.error('Upload Failed!. Please Upload again')
                        })
                })
        } else {
            addComment()
            setClearEditor(true)
        }
    }

    const getFileIcon = (name) => {
        const ext = name.split('.').pop().toLowerCase()
        switch (ext) {
            case 'pdf':
                return (
                    <FilePdfOutlined
                        style={{ fontSize: 20, color: '#ff4d4f' }}
                    />
                )
            case 'doc':
            case 'docx':
                return (
                    <FileWordOutlined
                        style={{ fontSize: 20, color: '#1890ff' }}
                    />
                )
            case 'xls':
            case 'xlsx':
                return (
                    <FileExcelOutlined
                        style={{ fontSize: 20, color: '#52c41a' }}
                    />
                )
            case 'png':
            case 'jpg':
            case 'jpeg':
                return (
                    <FileImageOutlined
                        style={{ fontSize: 20, color: '#722ed1' }}
                    />
                )
            default:
                return (
                    <FileOutlined style={{ fontSize: 20, color: '#595959' }} />
                )
        }
    }

    const handleChangeMentions = (newValue, newPlainTextValue, mentions) => {
        // const mentionNew =
        //     mentions?.length > 0 ? mentions.map((data) => data?.id) : []

        setMentionData({
            ...mentionData,
            value: newValue,
            comment: newPlainTextValue,
            mentionDataList: mentions,
        })
    }

    // Removed parseEstimationToMinutes - not needed for read-only

    // Removed create/update functionality - Support is view-only

    // useEffect(() => {
    //     if (taskFiles) {
    //         const allValues = form.getFieldsValue()
    //         debouncedAutoSave({ taskFiles }, allValues)
    //     }
    // }, [taskFiles])

    return (
        <>
            <Drawer
                placement="right"
                width={drawerWidth}
                style={{
                    height: '100vh',
                }}
                styles={{
                    body: {
                        padding: '0px',
                        scrollbarColor: 'auto',
                        overflowX: 'hidden',
                    },
                    wrapper: {
                        scrollbarColor: 'auto',
                    },
                    content: {
                        scrollbarColor: 'auto',
                    },
                }}
                rootClassName="taskHeader"
                onClose={onCloseTaskDrawer}
                closeIcon={null}
                open={formModal}
                title={
                    <Row
                        justify="end"
                        style={{
                            columnGap: '15px',
                        }}
                        align="center"
                    >
                        {selectedTask && (
                            <CopyTextButton
                                text={`${window.location.origin}${window.location.pathname}?taskId=${selectedTask?._id}`}
                            />
                        )}
                        <Tooltip title="Close" placement="top">
                            <Icon
                                icon="ph:arrow-line-right"
                                onClick={onCloseTaskDrawer}
                                height={20}
                                width={20}
                                style={{
                                    cursor: 'pointer',
                                }}
                            />
                        </Tooltip>
                    </Row>
                }
            >
                <Spin spinning={taskStatus === 'loading' ? true : false}>
                    <Form
                        layout="vertical"
                        name="addTaskForm"
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        form={form}
                        style={{
                            height: '100%',
                        }}
                        requiredMark={false}
                        initialValues={values}
                        // Removed onValuesChange - Support is read-only
                    >
                        <Flex gap={10}>
                            <Row
                                style={{
                                    overflow: 'auto',
                                    height: '100%',
                                }}
                            >
                                {selectedTask && (
                                    <div
                                        style={{
                                            width: '100%',
                                            padding: '15px 25px 0px 8px',
                                        }}
                                    >
                                        <Form.Item
                                            name="title"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Enter Task Title',
                                                    whitespace: true,
                                                },
                                                {
                                                    max: 400,
                                                    message:
                                                        'Title should be maximum 400 characters long',
                                                },
                                            ]}
                                            colon={false}
                                        >
                                            <Input
                                                placeholder={
                                                    'Write a Task Title'
                                                }
                                                name={'title'}
                                                readOnly={true}
                                                variant="borderless"
                                                className={[
                                                    styles.taskSelect,
                                                    styles.taskTitleInput,
                                                ]}
                                                onChange={(event) => {
                                                    updateDetails(
                                                        event.target.name,
                                                        event.target.value
                                                    )
                                                }}
                                            />
                                        </Form.Item>
                                    </div>
                                )}
                                <div
                                    style={{
                                        minHeight: '100%',
                                    }}
                                >
                                    <Row
                                        style={{
                                            padding: '0px',
                                        }}
                                    >
                                        <Row
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            <Row
                                                style={{
                                                    width: '100%',
                                                    marginBottom: '5px',
                                                    padding:
                                                        '15px 25px 0px 25px',
                                                }}
                                            >
                                                <Col span={24}>
                                                    {selectedTask && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Assignee
                                                            </span>

                                                            <Form.Item
                                                                name="assigneeId"
                                                                colon={false}
                                                                style={{
                                                                    width: '80%',
                                                                }}
                                                            >
                                                                <AssigneeSelectPopover
                                                                    searchable
                                                                    assigneeList={
                                                                        assigneeList
                                                                    }
                                                                    selectedAssignee={
                                                                        assigneeList?.length >
                                                                        0
                                                                            ? assigneeList.find(
                                                                                  (
                                                                                      data
                                                                                  ) =>
                                                                                      data?.value ===
                                                                                      values?.assigneeId
                                                                              )
                                                                            : null
                                                                    }
                                                                    onChange={(
                                                                        val
                                                                    ) =>
                                                                        updateDetails(
                                                                            'assigneeId',
                                                                            val
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        true
                                                                    }
                                                                    tooltipTitle="Select an assignee"
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}

                                                    {selectedTask && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                // justifyContent:
                                                                //     'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Type
                                                            </span>
                                                            <Form.Item
                                                                name="type"
                                                                rules={[
                                                                    {
                                                                        required: true,
                                                                        message:
                                                                            'Please Select a Task Type',
                                                                    },
                                                                ]}
                                                                colon={false}
                                                                style={{
                                                                    width: '30%',
                                                                }}
                                                            >
                                                                <TaskItemSelector
                                                                    placeholder="Select a Type"
                                                                    options={
                                                                        taskTypeOption
                                                                    }
                                                                    value={form.getFieldValue(
                                                                        'type'
                                                                    )}
                                                                    onChange={(
                                                                        val
                                                                    ) =>
                                                                        updateDetails(
                                                                            'type',
                                                                            val
                                                                        )
                                                                    }
                                                                    disabled={
                                                                        true
                                                                    }
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                            display: 'flex',
                                                            marginBottom:
                                                                '10px',
                                                            alignItems:
                                                                'center',
                                                            justifyContent:
                                                                'space-between',
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                width: '20%',
                                                            }}
                                                        >
                                                            Fields
                                                        </span>
                                                        <div
                                                            style={{
                                                                border: '1px solid #ededed',
                                                                borderRadius: 8,
                                                                width: '80%',
                                                            }}
                                                        >
                                                            <Row
                                                                style={{
                                                                    borderBottom:
                                                                        '1px solid #ededed',
                                                                    padding:
                                                                        '8px 12px',
                                                                    alignItems:
                                                                        'center',
                                                                }}
                                                            >
                                                                <Col span={8}>
                                                                    <span
                                                                        style={{
                                                                            color: '#595959',
                                                                        }}
                                                                    >
                                                                        Priority
                                                                    </span>
                                                                </Col>
                                                                <Col span={16}>
                                                                    <Form.Item
                                                                        name="priority"
                                                                        style={{
                                                                            marginBottom: 0,
                                                                        }}
                                                                    >
                                                                        <PrioritySelector
                                                                            priorityType={
                                                                                priorityType
                                                                            }
                                                                            name="priority"
                                                                            updateDetails={(
                                                                                name,
                                                                                value
                                                                            ) =>
                                                                                updateDetails(
                                                                                    name,
                                                                                    value
                                                                                )
                                                                            }
                                                                            disabled={
                                                                                true
                                                                            }
                                                                        />
                                                                    </Form.Item>
                                                                </Col>
                                                            </Row>
                                                            {selectedTask && (
                                                                <Row
                                                                    style={{
                                                                        padding:
                                                                            '8px 12px',
                                                                        alignItems:
                                                                            'center',
                                                                    }}
                                                                >
                                                                    <Col
                                                                        span={8}
                                                                    >
                                                                        <span
                                                                            style={{
                                                                                color: '#595959',
                                                                            }}
                                                                        >
                                                                            Status
                                                                        </span>
                                                                    </Col>
                                                                    <Col
                                                                        span={
                                                                            16
                                                                        }
                                                                    >
                                                                        <Form.Item
                                                                            name="status"
                                                                            style={{
                                                                                marginBottom: 0,
                                                                            }}
                                                                        >
                                                                            <StatusSelector
                                                                                statusType={
                                                                                    swimLanesOption
                                                                                }
                                                                                name="status"
                                                                                updateDetails={(
                                                                                    name,
                                                                                    value
                                                                                ) =>
                                                                                    updateDetails(
                                                                                        name,
                                                                                        value
                                                                                    )
                                                                                }
                                                                                disabled={
                                                                                    true
                                                                                }
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>
                                                                </Row>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {selectedTask && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Estimation
                                                            </span>
                                                            <Form.Item
                                                                name="estimation"
                                                                colon={false}
                                                                rules={[
                                                                    {
                                                                        validator:
                                                                            async (
                                                                                _,
                                                                                names
                                                                            ) => {
                                                                                if (
                                                                                    !names
                                                                                ) {
                                                                                    return Promise.resolve()
                                                                                }
                                                                                const pattern =
                                                                                    ESTIMATION_PATTERN

                                                                                const patternNumber =
                                                                                    /^[0-9]$/

                                                                                if (
                                                                                    !pattern.test(
                                                                                        names
                                                                                    ) &&
                                                                                    !patternNumber.test(
                                                                                        names
                                                                                    )
                                                                                ) {
                                                                                    return Promise.reject(
                                                                                        new Error(
                                                                                            'Your estimate must be in the format 2w 4d 6h 45m.'
                                                                                        )
                                                                                    )
                                                                                }
                                                                            },
                                                                    },
                                                                ]}
                                                                style={{
                                                                    width: '80%',
                                                                }}
                                                            >
                                                                <Input
                                                                    placeholder={
                                                                        '2w 4d 6h 45m'
                                                                    }
                                                                    style={{
                                                                        border: 'none',

                                                                        borderRadius:
                                                                            '8px',
                                                                        color: '#000',
                                                                        fontWeight: 500,
                                                                    }}
                                                                    className={
                                                                        styles.taskTextInput
                                                                    }
                                                                    readOnly={
                                                                        true
                                                                    }
                                                                    name={
                                                                        'estimation'
                                                                    }
                                                                    onBlurCapture={(
                                                                        event
                                                                    ) => {
                                                                        if (
                                                                            event
                                                                                .target
                                                                                .value
                                                                                ?.length >
                                                                            0
                                                                        )
                                                                            checkFinalEstimation(
                                                                                event.target.value.trimEnd()
                                                                            )
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                    {selectedTask && (
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                display: 'flex',
                                                                marginBottom:
                                                                    '10px',
                                                                alignItems:
                                                                    'center',
                                                                justifyContent:
                                                                    'space-between',
                                                            }}
                                                        >
                                                            <span
                                                                style={{
                                                                    width: '20%',
                                                                }}
                                                            >
                                                                Date :
                                                            </span>
                                                            <Form.Item
                                                                colon={false}
                                                                name={
                                                                    'rangePicker'
                                                                }
                                                                className="rangePickerTask"
                                                                style={{
                                                                    width: '80%',
                                                                }}
                                                            >
                                                                <RangePicker
                                                                    picker={
                                                                        'date'
                                                                    }
                                                                    allowClear={
                                                                        false
                                                                    }
                                                                    readOnly={[
                                                                        true,
                                                                        false,
                                                                    ]}
                                                                    name={
                                                                        'rangePicker'
                                                                    }
                                                                    format={
                                                                        formatDatePicker
                                                                    }
                                                                    style={{
                                                                        width: '100%',
                                                                    }}
                                                                    bordered={
                                                                        false
                                                                    }
                                                                    disabled={
                                                                        true
                                                                    }
                                                                    className={[
                                                                        styles.taskSelect,
                                                                    ]}
                                                                    onChange={(
                                                                        event
                                                                    ) => {
                                                                        if (
                                                                            form.getFieldValue(
                                                                                'start'
                                                                            ) !==
                                                                                undefined &&
                                                                            new Date(
                                                                                form.getFieldValue(
                                                                                    'start'
                                                                                )[
                                                                                    '$d'
                                                                                ]
                                                                            ).setHours(
                                                                                0,
                                                                                0,
                                                                                0,
                                                                                0
                                                                            ) !==
                                                                                new Date(
                                                                                    event[0][
                                                                                        '$d'
                                                                                    ]
                                                                                ).setHours(
                                                                                    0,
                                                                                    0,
                                                                                    0,
                                                                                    0
                                                                                ) &&
                                                                            selectedTask
                                                                        ) {
                                                                            setUpdatedValues(
                                                                                {
                                                                                    ...updatedValues,
                                                                                    start: new Date(
                                                                                        event[0][
                                                                                            '$d'
                                                                                        ]
                                                                                    ).setHours(
                                                                                        23,
                                                                                        59,
                                                                                        59,
                                                                                        999
                                                                                    ),
                                                                                }
                                                                            )
                                                                        }
                                                                        if (
                                                                            form.getFieldValue(
                                                                                'end'
                                                                            ) !==
                                                                                undefined &&
                                                                            new Date(
                                                                                form.getFieldValue(
                                                                                    'end'
                                                                                )[
                                                                                    '$d'
                                                                                ]
                                                                            ).setHours(
                                                                                23,
                                                                                59,
                                                                                59,
                                                                                999
                                                                            ) !==
                                                                                new Date(
                                                                                    event[1][
                                                                                        '$d'
                                                                                    ]
                                                                                ).setHours(
                                                                                    23,
                                                                                    59,
                                                                                    59,
                                                                                    999
                                                                                ) &&
                                                                            selectedTask
                                                                        ) {
                                                                            setUpdatedValues(
                                                                                {
                                                                                    ...updatedValues,
                                                                                    end: new Date(
                                                                                        event[1][
                                                                                            '$d'
                                                                                        ]
                                                                                    ).setHours(
                                                                                        23,
                                                                                        59,
                                                                                        59,
                                                                                        999
                                                                                    ),
                                                                                }
                                                                            )
                                                                        }
                                                                        setValues(
                                                                            {
                                                                                ...values,
                                                                                start: event[0],
                                                                                end: event[1],
                                                                            }
                                                                        )
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </div>
                                                    )}
                                                </Col>
                                                <Col
                                                    span={24}
                                                    style={{
                                                        marginTop: '20px',
                                                    }}
                                                >
                                                    <span>Description</span>
                                                    <Form.Item
                                                        name="description"
                                                        colon={false}
                                                        style={{
                                                            marginTop: '5px',
                                                        }}
                                                    >
                                                        <TextArea
                                                            rows={6}
                                                            placeholder={
                                                                'What is this task about?'
                                                            }
                                                            readOnly={true}
                                                            className={
                                                                styles.taskTextArea
                                                            }
                                                            name={'description'}
                                                            onChange={(event) =>
                                                                updateDetails(
                                                                    event.target
                                                                        .name,
                                                                    event.target
                                                                        .value
                                                                )
                                                            }
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            {selectedTask && (
                                                <Col
                                                    span={24}
                                                    style={{
                                                        marginTop: '10px',
                                                    }}
                                                >
                                                    <SupportSubTaskSection
                                                        assigneeList={
                                                            assigneeList
                                                        }
                                                        taskTypeOption={
                                                            taskTypeOption
                                                        }
                                                        swimLanesOptionTask={
                                                            swimLanesOption
                                                        }
                                                    />
                                                </Col>
                                            )}
                                            <div
                                                style={{
                                                    padding: '15px 25px',
                                                }}
                                            >
                                                <SupportAttachmentSection />
                                            </div>
                                            {selectedTask && (
                                                <Row
                                                    style={{
                                                        width: '100%',
                                                        padding: '15px 25px',
                                                    }}
                                                >
                                                    <Col span={24}>
                                                        <Tabs
                                                            defaultActiveKey={
                                                                'sub-tasks'
                                                            }
                                                            onChange={(key) =>
                                                                setActiveTabComment(
                                                                    key
                                                                )
                                                            }
                                                            items={tabs}
                                                            className="generalTabs"
                                                        />
                                                    </Col>
                                                </Row>
                                            )}
                                        </Row>
                                    </Row>
                                </div>
                            </Row>
                        </Flex>
                        {activeTabComment === 'comments' && (
                            <div
                                style={{
                                    borderTop: '1px solid #f0f0f0',
                                    padding: '16px 24px',
                                    background: '#fff',
                                    // textAlign: 'right',
                                    position: 'sticky',
                                    bottom: 0,
                                    zIndex: 10,
                                }}
                            >
                                <div
                                    style={{
                                        marginBottom: '10px',
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                    }}
                                >
                                    {files?.length > 0 && (
                                        <>
                                            <Row gutter={[12, 12]}>
                                                {files.map((file, index) => {
                                                    const maxChars = 8
                                                    const displayName =
                                                        file?.name?.length >
                                                        maxChars
                                                            ? file?.name.slice(
                                                                  0,
                                                                  maxChars
                                                              ) + '…'
                                                            : file?.name

                                                    return (
                                                        <Col
                                                            key={index}
                                                            xs={24}
                                                            sm={12}
                                                            md={8}
                                                            lg={8}
                                                        >
                                                            <Card
                                                                size="small"
                                                                hoverable
                                                                style={{
                                                                    borderRadius: 12,
                                                                    background:
                                                                        '#fafafa',
                                                                    boxShadow:
                                                                        '0 2px 6px rgba(0,0,0,0.05)',
                                                                    padding:
                                                                        '5px 5px',
                                                                }}
                                                            >
                                                                <Space
                                                                    style={{
                                                                        marginRight:
                                                                            '10px',
                                                                    }}
                                                                >
                                                                    {getFileIcon(
                                                                        file?.name
                                                                    )}
                                                                    <Tooltip
                                                                        title={
                                                                            file?.name
                                                                        }
                                                                    >
                                                                        <Text>
                                                                            {
                                                                                displayName
                                                                            }
                                                                        </Text>
                                                                    </Tooltip>
                                                                </Space>
                                                            </Card>
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </>
                                    )}
                                </div>

                                <Row gutter={[10, 10]} align="top">
                                    {/* Editor takes most of the width */}
                                    <Col xs={24} sm={24} md={20} lg={22}>
                                        <MentionEditor
                                            member={filteredMembers}
                                            handleChangeMentions={
                                                handleChangeMentions
                                            }
                                            value={mentionData?.value}
                                            clearTrigger={clearEditor}
                                            loadingButton={addCommentLoader}
                                            onClickComment={() => s3Upload()}
                                            disabledButton={false}
                                        />
                                    </Col>

                                    {/* Attachment button */}
                                    <Col xs={24} sm={24} md={4} lg={2}>
                                        <SupportAttachmentSectionButton
                                            isText={true}
                                            getFileList={(files) => {
                                                setFiles(files)
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Form>
                </Spin>
            </Drawer>
        </>
    )
}

export default SupportTaskForm
